/*
 * HOTFIX 2026-10-12, entry 2 (unit HF1). WHICH ROUTED ERRORS TAKE THE PAGE.
 *
 * `Vue.config.errorHandler` in `resources/js/app.js` draws the page-level error state (T33b, Log #374)
 * only when this answers true. On the live code every error Vue routes there was logged and the page
 * stayed usable; T33b drew the state on ALL of them, so a latent throw in a click handler, a watcher or
 * a component's event listener took the whole page, chrome included, on every module. This narrows the
 * state back to the one failure that leaves the page with nothing to draw: its own render.
 *
 * TRUE only when BOTH hold:
 *   (i)  `info === 'render'`, by strict equality. That string is Vue 2.6.14's own for a throw inside a
 *        component's render (`vue.common.dev.js` `Vue.prototype._render`). Every other info Vue sends is
 *        logged only: 'v-on handler', 'event handler for "<event>"', 'callback for watcher "..."',
 *        'callback for immediate watcher "..."', 'getter for watcher "..."', 'nextTick',
 *        'directive <name> <hook> hook', every '<name> hook', every '... (Promise/async)', and 'data()'.
 *        A throw in `data()` leaves the data `{}` and a throw in a lifecycle hook is caught per handler
 *        while the component still renders and mounts, so none of them leaves the page blank.
 *   (ii) `vm` is set and lies at most three `$parent` steps below `vm.$root`: `$root` -> the
 *        `dynamic-component` (`home.blade.php`, `item.blade.php`) -> the routed page -> the page's direct
 *        child (for one, `MyLayout`). A render failure deeper than that is a hole inside a page that
 *        still draws, and is logged only.
 *
 * It is not gated on `uses_curated_screens`: the boundary is the same on every module. This module has
 * no import and no dependency, so a node harness can load it as it is.
 */
export function shouldDrawPageError(vm, info) {
    if (info !== 'render') {
        return false;
    }
    if (!vm) {
        return false;
    }
    let d = 0, n = vm;
    while (n && n.$parent) { n = n.$parent; d++; }
    return d <= 3;
}
